<div class="transport-item-line row align-items-center">
  <div class="col-sm-3 col-xl-auto d-inline-flex align-items-center mw-xl-140">
    <div class="icon left-icon mr-2" [mdbTooltip]="getTypology()?.label | translate">
      <i [class]="getTypology()?.icon"></i>
    </div>
    <div class="icon" [mdbTooltip]="handlingTypeItem.labelKey | translate">
      <i [class]="handlingTypeItem.icon"></i>
    </div>
    <span class="labelType px-2">{{ handlingTypeItem.labelKey | translate }}</span>
  </div>
  <div class="col-10 col-sm-7 col-xl">
    <div class="attributes row align-items-center flex-wrap">
      <div class="col-lg-5 col-xl-auto mw-xl-140">
        <span jhiTranslate="components.transport-item-line.quantity" class="attribute"></span>
        <span data-id-cypress="item-line-quantity">{{ item.quantity }}</span>
      </div>
      <div class="col-lg-7 col-xl-auto mw-xl-220">
        <span jhiTranslate="components.transport-item-line.size" class="attribute"></span>
        <span jhiTranslate="components.transport-item-line.size-value" data-id-cypress="item-line-size" [translateValues]="{ width: item.width, length: item.length }"></span>
      </div>
      <div class="col-lg-5 col-xl-auto mw-xl-140">
        <span jhiTranslate="components.transport-item-line.weight" class="attribute"></span>
        <span jhiTranslate="components.transport-item-line.weight-value" data-id-cypress="item-line-weight" [translateValues]="{ weight: item.weight }"></span>
      </div>
      <div class="col-lg-7 col-xl-auto mw-xl-220">
        <span jhiTranslate="components.transport-item-line.maxHeight" class="attribute"></span>
        <span jhiTranslate="components.transport-item-line.maxHeight-value" data-id-cypress="item-line-max-height" [translateValues]="{ maxHeight: item.maxHeight }"></span>
      </div>
    </div>
  </div>
  <div class="buttons col-2 col-xl-1">
    <div class="d-inline-flex align-items-center float-right">
      <jhi-bary-specific-button class="pr-1" type="editButton" (click)="editEvent.emit()"></jhi-bary-specific-button>
      <jhi-bary-specific-button type="trashButton" (click)="deleteEvent.emit()"></jhi-bary-specific-button>
    </div>
  </div>
</div>
